export default class Session {
  constructor(client) {
    this.client = client;
  }

  login(path, username, password) {
    this.setBasePath(path);
    return this.client.post(`/login`, { username, password });
  }
  logout() {
    return this.client.delete(`/logout`);
  }
  getSession(path) {
    this.setBasePath(path);
    return this.client.get(`/sessions/current`).then((resp) => resp.data);
  }

  setBasePath(path) {
    this.client.interceptors.request.use(function(config) {
      let baseURL = new URL(config.baseURL);
      baseURL.pathname = path;

      config.baseURL = baseURL.href;

      return config;
    });
  }
}
